var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrosshair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 16.963V14C8.25 13.5858 8.58579 13.25 9 13.25C9.41421 13.25 9.75 13.5858 9.75 14V16.963C13.2933 16.6112 16.1112 13.7933 16.463 10.25H13.5C13.0858 10.25 12.75 9.91421 12.75 9.5C12.75 9.08579 13.0858 8.75 13.5 8.75H16.463C16.1112 5.20669 13.2933 2.38883 9.75 2.03703V5C9.75 5.41421 9.41421 5.75 9 5.75C8.58579 5.75 8.25 5.41421 8.25 5V2.03703C4.70669 2.38883 1.88883 5.20669 1.53703 8.75H4.5C4.91421 8.75 5.25 9.08579 5.25 9.5C5.25 9.91421 4.91421 10.25 4.5 10.25H1.53703C1.88883 13.7933 4.70669 16.6112 8.25 16.963ZM18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5ZM10.5 9.5C10.5 10.3284 9.82843 11 9 11C8.17157 11 7.5 10.3284 7.5 9.5C7.5 8.67157 8.17157 8 9 8C9.82843 8 10.5 8.67157 10.5 9.5ZM12 9.5C12 11.1569 10.6569 12.5 9 12.5C7.34315 12.5 6 11.1569 6 9.5C6 7.84315 7.34315 6.5 9 6.5C10.6569 6.5 12 7.84315 12 9.5Z",
    fill: "#0956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair);
export default __webpack_public_path__ + "static/media/crosshair.c40bccb8eb3ae4355c6c08f6d1d77b48.svg";
export { ForwardRef as ReactComponent };